export default __webpack_public_path__ + "static/media/1m.65970691.svg";